<template>
  <header class="bg-white shadow-md p-1">
    <div class="flex items-center justify-between">
      <h2 class="text-base font-semibold text-gray-800">{{ authStore.user?.branchName }}</h2>
      <div class="relative">
        <!-- 프로필 메뉴 -->
        <div @click="toggleProfileMenu" class="flex items-center space-x-1.5 cursor-pointer">
          <div class="w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center">
            <UserIcon size="14" class="text-gray-600" />
          </div>
          <!-- <div class="block">
            <span class="text-gray-700 font-medium">{{ authStore.user?.branchName }}</span>
          </div> -->
          <ChevronDownIcon size="14" class="text-gray-500" />
        </div>

        <!-- 오버레이 -->
        <div v-if="isProfileMenuOpen" class="fixed inset-0 z-20" @click="toggleProfileMenu"></div>

        <!-- 드롭다운 메뉴 -->
        <div v-if="isProfileMenuOpen"
          class="absolute right-0 mt-1 w-40 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-30">
          <div class="py-0.5" role="menu">
            <button @click="handleLogout" class="w-full text-left px-3 py-1.5 text-xs text-red-600 hover:bg-gray-100"
              role="menuitem">
              <LogOutIcon size="12" class="inline-block mr-1.5" />
              로그아웃
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { UserIcon, ChevronDownIcon, LogOutIcon } from 'lucide-vue-next'
import { authAPI, removeToken } from '@/api/apiClient'

const authStore = useAuthStore()
const router = useRouter()
const isProfileMenuOpen = ref(false)

const toggleProfileMenu = () => {
  isProfileMenuOpen.value = !isProfileMenuOpen.value
}

const handleLogout = async () => {
  try {
    await authAPI.logout()
    removeToken()
    authStore.$reset()
    router.push('/login')
  } catch (error) {
    console.error('로그아웃 중 오류 발생:', error)
  }
}
</script>